export const IclrcMpMessages = {
  login: {
    submit: "Sign in",
  },
}
